import Home from '../../containers/home/index'

export default function HomePage() {
    return <Home />
}
